import { isServer, useTokenValue } from '@sail/engine';
import { useEffect, useRef, useState } from 'react';
import { tokens } from '@sail/tokens/deprecated';
import { uiRpc } from '../../../lib/ui-rpc/rpc';
export const useRpcMatchMedia = (query, options = {})=>{
    const stableOptions = useRef(options);
    stableOptions.current = options;
    // We can not run window.matchMedia on the server.
    // This needs to be initialized with the same value in server and client to avoid hydration mismatches.
    const [matches, setMatches] = useState(null);
    useEffect(()=>{
        var _window;
        const supportsMatchMedia = typeof window !== 'undefined' && typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.matchMedia) === 'function';
        if (!supportsMatchMedia || isServer || !(uiRpc === null || uiRpc === void 0 ? void 0 : uiRpc.client)) {
            return;
        }
        const unsubscribe = uiRpc.client.watch('matchMedia', {
            query
        }, ({ matches })=>{
            var _stableOptions_current_onChange, _stableOptions_current;
            setMatches(matches);
            (_stableOptions_current = stableOptions.current) === null || _stableOptions_current === void 0 ? void 0 : (_stableOptions_current_onChange = _stableOptions_current.onChange) === null || _stableOptions_current_onChange === void 0 ? void 0 : _stableOptions_current_onChange.call(_stableOptions_current, matches);
        });
        return unsubscribe;
    }, [
        query
    ]);
    return matches;
};
export const useRpcMediaMaxWidth = (viewport, options)=>{
    return useRpcMatchMedia(`(max-width: ${viewport})`, options);
};
export const useRpcMediaAnyCoarsePointer = (options)=>{
    return useRpcMatchMedia('(any-pointer: coarse)', options);
};
export const useRpcMediaSmallScreen = (options)=>{
    const viewport = useTokenValue(tokens.viewport.small);
    return useRpcMediaMaxWidth(viewport, options);
};
export const useRpcMediaSmallScreenAndTouch = ()=>{
    const isSmallScreen = useRpcMediaSmallScreen();
    const isAnyCoarsePointer = useRpcMediaAnyCoarsePointer();
    return isSmallScreen && isAnyCoarsePointer;
};

//# sourceMappingURL=useRpcMatchMedia.js.map